import React from 'react';
import CircadiaFullWidthBarChart from '../../../../components/GraphBox/Components/CircadiaFullWidthBarChart.tsx';
import { useSelector } from 'react-redux';
import { useGetAssetCountByEndDateQuery } from '../../../../api/asset.api.ts';
import { selectActiveFilters } from '../../../../redux/slices/filterSlice.ts';
import { selectAccount } from '../../../../redux/slices/accountSlice';

interface AssetByEndDateChartProps {
	registerExportFn?: (exportFn: () => void) => void;
}

const AssetByEndDateChart: React.FC<AssetByEndDateChartProps> = ({ registerExportFn }) => {
	const activeFilters = useSelector(selectActiveFilters);
	const account = useSelector(selectAccount);
	const accountId = account?.accountId ?? 0;
	const sourceId = account?.sourceId ?? 0;
	const accountTypeCode = account?.accountTypeCode ?? '';

	const { data: assetCountByEndDate = [] } = useGetAssetCountByEndDateQuery(
		{ sourceId, accountId, accountTypeCode, filters: activeFilters },
		{ skip: !accountId }
	);

	return (
		<CircadiaFullWidthBarChart
			title="Asset By End of Lease Date"
			xaxislabel="Asset End Date"
			yaxislabel="Total Assets"
			data={assetCountByEndDate}
			registerExportFn={registerExportFn}
		/>
	);
};

export default AssetByEndDateChart;
